namespace Matrix.Data {
    export interface DataReportProperties {
        VisibleSheets?: string[];
    }
}
